import {Component, OnDestroy, OnInit} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {formatDate, NgForOf, NgIf} from "@angular/common";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {User} from "../../../services/user/user";
import {BehaviorSubject, Subscription} from "rxjs";
import {GridOptions} from "ag-grid-community";
import {UserService} from "../../../services/user/user.service";
import {AlertService} from "../../../services/alert/alert.service";
import {IffShipmentDetailsService} from "../../../services/iff-shipment-details/iff-shipment-details.service";
import {Router} from "@angular/router";
import {LoadingService} from "../../../services/loading/loading.service";
import {takeWhile} from "rxjs/operators";
import {CommonHelpers} from "../../../shared/common-helpers";
import {XTOSReportingService} from "../../../services/XTOS-reporting/xtos-reporting.service";
import * as Constants from "../../../shared/common-components/AppConstants";

@Component({
    selector: 'app-xtos-comprehensive-reporting',
    imports: [
        AgGridAngular,
        NgForOf,
        NgIf,
        ReactiveFormsModule
    ],
    templateUrl: './xtos-comprehensive-reporting.component.html',
    styleUrl: './xtos-comprehensive-reporting.component.css'
})
export class XtosComprehensiveReportingComponent implements OnInit, OnDestroy{
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  carrier_user = Constants.carrier_user;
  carrier_user_admin = Constants.carrier_user_admin;
  carrier_user_RF = Constants.carrier_user_RF;
  system_admin = Constants.system_admin;
  currentUser: User | any;
  private observer$ = new BehaviorSubject(true);
  xtosComprehensiveFormGroup: UntypedFormGroup;
  resultsSubscription = new Subscription();
  public reportingYrList = [];
  reportingYr: number;
  reportingQtr = 0;
  currrentYr = 0;
  carrierEntity: any;
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };

  format = 'MM/dd/yyyy';
  locale = 'en-US';
  private gridApi;
  public gridColumnApi;
  columnsDefs: any;
  rowData: any;

  xtosComprensivecolumnDefs = [
    {
      headerName: 'SCAC',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Shipment Report Contact Name',
      valueGetter: (params: any) => {
        return (params.data.firstName || params.data.lastName || params.data.email) ?
          (params.data.firstName + ' ' + params.data.lastName) : 'Not Available';
      },
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Shipment Report Contact Email',
      valueGetter: (params: any) => {
        return (params.data.email) ?
          (params.data.email) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'FAIC',
      field: 'faicCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Point of Contact',
      valueGetter: params => {
        return params.data.pofContact ? params.data.pofContact : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'agencyBureauName',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Reference Number',
      field: 'proBillNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Bill of Lading Number',
      field: 'bolNumber',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Storage Type',
      field: 'transportationType',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Pickup Date',
      valueGetter: (params) => {
        return params.data.pickupDate ? (formatDate(params.data.pickupDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Date into Extended Storage',
      valueGetter: (params) => {
        return params.data.deliveryDate ? (formatDate(params.data.deliveryDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Billing Date',
      valueGetter: (params) => {
        return params.data.billingDate ? (formatDate(params.data.billingDate , this.format, this.locale)) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Storage Location',
      field: 'storageLoc',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Storage Zip',
      field: 'storageZip',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Storage Address',
      field: 'storageAddr',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Employee Last Name',
      field: 'employeeLastName',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Point of Contact Email',
      valueGetter: (params: any) => {
        return (params.data.email) ?
                  (params.data.email) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Total Amount Invoiced',
      field: 'amountInvoiced',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Pass Thru Amt',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Total AF',
      field: 'totalIFF',
      filter: 'agTextColumnFilter',
      sortable: true,
      cellRenderer: params => {
        this.gridColumnApi.setColumnVisible('totalIFF', true);
        return params.data.totalIFF;
      }

    },
    {
      headerName: 'SRO Code',
      field: 'sroCode',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter', sortable: true
    }
  ];
  excelStyles: any = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];

  /**
   * @description defines the button renderer component to show the smartWay button based on the flag.
   */
  constructor(private userService: UserService, private alertService: AlertService, private shipmentDetailService: IffShipmentDetailsService,
              private fb: UntypedFormBuilder, private router: Router, private loader: LoadingService, private xtosReportingService: XTOSReportingService,) {

  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
    this.gridColumnApi = params.columnApi;
  }

  /**
   * @description manipulates row data according to the desired results and generates columns dynamically by looping through rowData.
   */
  ngOnInit() {
    this.xtosComprehensiveFormGroup = this.fb.group({
      reportingYrSelect: new UntypedFormControl('', Validators.required),
      reportingQtrSelect: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(4)])

    });
    this.currrentYr = new Date().getFullYear();
    this.reportingYrList.push({name: this.currrentYr, value: this.currrentYr});
    for (let i = 1; i < 7; i++) {
      const previousYr = this.currrentYr - i;
      this.reportingYrList.push({name: previousYr, value: previousYr});
    }
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });

  }
  onShipmentReportClicked(){
    this.router.navigate(['/tspSitShpmntRptStatus']);
  }
  getSITCompresensiveDetails() {
    this.loader.show();
    this.resultsSubscription = this.xtosReportingService.getXTOSComprehensiveReport(this.reportingYr, this.reportingQtr).subscribe(res => {
      console.log ('res.length ' + res.length);
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = CommonHelpers.sortAtoZ(res);
        this.columnsDefs = this.xtosComprensivecolumnDefs;
        this.loader.hide();
      } else {
        this.rowData = null;
        this.loader.hide();
      }
    });
  }
  onReportYrChange(reportYr: number) {
    this.reportingYr = reportYr;
  }
  onReportQtrChange(reportQtr: number) {
    this.reportingQtr = reportQtr;
  }

  /**
   * @description exports all the grid data from the datasource into a csv file using ag-grid api
   */
  onBtExport() {
    const date = new Date();
    const params = {
      fileName: 'sit-comprehensive-report-' + date + '.csv',
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params);
  }

  checkUserRole(roles?) {
    return CommonHelpers.checkUserRoles(this.currentUser, roles);
  }

  ngOnDestroy(): void {
    this.resultsSubscription.unsubscribe();
  }

}

